import muestras_de_Jacaranda_mimosifolia from '../assets/images/publicaciones/muestras_de_Jacaranda_mimosifolia.png'
import percepcion_social_del_arbolado_urbano from '../assets/images/publicaciones/percepcion_social_del_arbolado_urbano.png'
import aplicacion_estudiantes from '../assets/images/publicaciones/aplicacion_estudiantes.png'
import software_master from '../assets/images/publicaciones/software_master.png'
import propiedades_suelo from '../assets/images/publicaciones/propiedades_suelo.png'
import crecimiento_arboles from '../assets/images/publicaciones/crecimiento_arboles.png'
import comparacion_de_perfiles from '../assets/images/publicaciones/comparacion_de_perfiles.png'
import alnus_acuminata_Kunth from '../assets/images/publicaciones/alnus_acuminata_Kunth.png'
import principales_ventajas from '../assets/images/publicaciones/principales_ventajas.png'
import acacia_macracantha from '../assets/images/publicaciones/acacia_macracantha.png'
import belleza_ecosistema from '../assets/images/publicaciones/belleza_ecosistema.png'
import interfaz_aplicacion from '../assets/images/publicaciones/interfaz_aplicacion.png'
import caracterizacion_anatomica_cuantitativa from '../assets/images/publicaciones/caracterizacion_anatomica_cuantitativa.png'
import enfermedades_fungosa from '../assets/images/publicaciones/enfermedades_fungosa.png'
import belleza_orillas_zamora from '../assets/images/publicaciones/belleza_orillas_zamora.png'
import anillos_crecimiento from '../assets/images/publicaciones/anillos_crecimiento.png'
import enfermedad_fungosa from '../assets/images/publicaciones/enfermedad_fungosa.png'
import interfaz_cel from '../assets/images/publicaciones/interfaz_cel.png'
import carbono_arbolado from '../assets/images/publicaciones/carbono_arbolado.png'
import densidad from '../assets/images/publicaciones/densidad.png'
import patron_anillos from '../assets/images/publicaciones/patron_anillos.png'
import podocarpus_oleifolius from '../assets/images/publicaciones/podocarpus_oleifolius.png'

export const publicacionesImages = {
  muestras_de_Jacaranda_mimosifolia,
  percepcion_social_del_arbolado_urbano,
  aplicacion_estudiantes,
  software_master,
  propiedades_suelo,
  crecimiento_arboles,
  comparacion_de_perfiles,
  alnus_acuminata_Kunth,
  principales_ventajas,
  acacia_macracantha,
  belleza_ecosistema,
  interfaz_aplicacion,
  caracterizacion_anatomica_cuantitativa,
  enfermedades_fungosa,
  belleza_orillas_zamora,
  anillos_crecimiento,
  enfermedad_fungosa,
  interfaz_cel,
  carbono_arbolado,
  densidad,
  patron_anillos,
  podocarpus_oleifolius,
}

export const tesisData = [
  {
    title:
      'Formación de anillos de crecimiento por estrés hídrico y defoliación en Handroanthus chrysanthus (Jacq.) S.O.Grose y Cedrela montana Moritz ex Turcz.,bajo condiciones controladas en la ciudad de Loja',
    autores: 'Ordóñez Guamán, Erika Mercedes',
    date: '2025-11-13',
    image: 'podocarpus_oleifolius',
    link: 'https://dspace.unl.edu.ec/items/89e60c86-f61a-4667-b21d-d22b2492ad87/full',
  },
  {
    title:
      'Influencia del sitio en la estructura anatómica de la madera de 10 especies forestales en la ciudad de Loja',
    image: 'comparacion_de_perfiles',
    authors: 'Cabrera Malla, Nathalia Ximena',
    date: '2025-06-12',
    link: 'https://dspace.unl.edu.ec/items/52d69795-e0c3-4305-a14e-57e63e8a2ed2',
  },
  {
    title:
      'Medición de la Eficiencia del Aplicativo Móvil Árbol QR utilizando el Modelo de Calidad en Uso basado en la Norma ISO/IEC 25022',
    image: 'aplicacion_estudiantes',
    authors: 'Rivera Guamán, Ramiro Rene',
    date: '2025-05-29',
    link: 'https://dspace.unl.edu.ec/items/fbceb166-6291-4e03-9c3b-16e1a0b9b422',
  },
  {
    title:
      'Medición de la usabilidad del aplicativo móvil “Árbol QR” mediante un modelo de calidad de producto basado en las normas ISO/IEC 25023',
    autores: 'Sánchez Chiriboga, Luis Miguel',
    date: '2025-03-19',
    image: 'software_master',
    link: 'https://dspace.unl.edu.ec/items/ec0f98ea-988a-45e1-9b67-1b3bdbaf43a7/full',
  },
  {
    title:
      'Relación entre las propiedades químicas del suelo, la composición química y las propiedades físicas de madera de Acacia macracantha Humb. & Bonpl.ex Willd, en la ciudad de Loja',
    image: 'acacia_macracantha',
    authors: 'Chimbo Granda, María Belén',
    date: '2024-09-13',
    link: 'https://dspace.unl.edu.ec/items/c755cdb5-6698-449c-9845-ac3dc96ad920',
  },
  {
    title:
      'Estimación anual del carbono almacenado en la biomasa aérea de especies exóticas en el arbolado urbano de la ciudad de la Loja',
    autores: 'Chicaiza Sanchez, Jorge Luis',
    date: '2024-09-06',
    image: 'patron_anillos',
    link: 'https://dspace.unl.edu.ec/items/ec0db27e-3f03-4af3-8c30-c46ff42d7fa2/full',
  },
  {
    title:
      'Estimación anual del carbono almacenado en la biomasa aérea de especies nativas en el arbolado urbano de la ciudad de Loja',
    image: 'crecimiento_arboles',
    authors: 'Cabrera Puglla, Odallys Fernanda',
    date: '2024-09-06',
    link: 'https://dspace.unl.edu.ec/items/52b44b46-01cb-4f69-80f2-9b5f07f1ad4a',
  },
  {
    title:
      'Formación de anillos de crecimiento por estrés hídrico y defoliación en Juglans neotropica Diels y Podocarpus oleifolius D. Don. bajo condiciones controladas en la ciudad de Loja',
    autores: 'Ordóñez González, Deysy Laura',
    date: '2024-08-01',
    image: 'anillos_crecimiento',
    link: 'https://dspace.unl.edu.ec/items/89e60c86-f61a-4667-b21d-d22b2492ad87',
  },
  {
    title:
      'Valoración de los servicios ecosistémicos del arbolado urbano del sector norte de la ciudad de Loja, Ecuador',
    image: 'percepcion_social_del_arbolado_urbano',
    authors: 'Gualán Gordillo, Ronald Fabian',
    date: '2024-06-25',
    link: 'hhttps://dspace.unl.edu.ec/items/98500ec0-d90c-4282-b0fd-ebb19ae2bad6/full',
  },
  {
    title:
      'Relación entre las propiedades químicas del suelo, la composición química y las propiedades físicas de madera de Alnus acuminata Kunth, en la ciudad de Loja',
    image: 'alnus_acuminata_Kunth',
    authors: 'Rosales Torres, Mónica Daniela',
    date: '2024-06-12',
    link: 'https://dspace.unl.edu.ec/items/f7a2d384-7608-4051-9aaf-43bccb6e33fe',
  },
  {
    title:
      'Front-end versión 2.0 para el inventario in-situ como herramienta del proyecto de investigación “Dinámica de crecimiento y servicios ecosistémicos del arbolado urbano de la ciudad de Loja',
    autores: 'Toledo Iñiguez, Carmen Azucena',
    date: '2024-05-09',
    image: 'interfaz_cel',
    link: 'https://dspace.unl.edu.ec/items/233d64fe-d39f-459e-a95b-bb30a90c0622',
  },
  {
    title:
      'Identificación y valoración de los servicios ecosistémicos del arbolado urbano en el sur de la ciudad de Loja',
    image: 'principales_ventajas',
    authors: 'Macas Vera, Maria Fernanda',
    date: '2024-04-16',
    link: 'https://dspace.unl.edu.ec/items/50f789e4-c9ec-431b-aff7-21f3b2120bda',
  },
  {
    title:
      'Aplicación web para la gestión de la representatividad de árboles urbanos del proyecto de investigación Dinámica de crecimiento y servicios ecosistémicos del arbolado urbano de la ciudad de Loja',
    autores: 'González Guamán, Johnny Fabián',
    date: '2023-03-28',
    image: 'interfaz_aplicacion',
    link: 'https://dspace.unl.edu.ec/items/6fc7e197-dc5b-4c97-933e-7bc0d74e117f',
  },
  {
    title:
      'La belleza escénica y los servicios ecosistémicos de los árboles urbanos del Parque Lineal la Tebaida de la ciudad de Loja, Ecuador',
    autores: 'Celi Ramírez, Laura Katherine',
    date: '2023-03-16',
    image: 'belleza_ecosistema',
    link: 'https://dspace.unl.edu.ec/items/b2ec85d5-d221-43a2-b694-b116b3189d16',
  },
  {
    title:
      'Evaluación de la relación entre las propiedades físicas y químicas de la madera en Salix humboldtiana, árbol patrimonial de la ciudad de Loja.',
    autores: 'Carpio Vega, Briggette Melania',
    date: '2024-03-12',
    image: 'densidad',
    link: 'https://dspace.unl.edu.ec/items/c9c22a1e-78d6-4f46-9f0d-5f5d52238e89',
  },
  {
    title:
      'Evaluación de enfermedades fungosas del arbolado urbano en parques de la ciudad de Loja',
    autores: 'Lima Veintmilla, Erika Valeria',
    date: '2024-02-21',
    image: 'enfermedades_fungosa',
    link: 'https://dspace.unl.edu.ec/items/4e1ba540-8c18-4a66-99a4-d85cad8c4187',
  },
  {
    title:
      'Diversidad y almacenamiento de carbono del arbolado urbano en la ciudad de Loja, Ecuador',
    autores: 'Merino Galvez, Bryan Javier',
    date: '2024-02-15',
    image: 'carbono_arbolado',
    link: 'https://dspace.unl.edu.ec/items/27ceab69-8523-4ed2-804a-c952655f44fd',
  },
  {
    title:
      'Evaluación de enfermedades fungosas del arbolado urbano de las avenidas de la ciudad de Loja',
    autores: 'Troya Alverca, Danny Israel',
    date: '2023-03-28',
    image: 'enfermedad_fungosa',
    link: 'https://dspace.unl.edu.ec/items/63702b0d-33c1-41cc-85d7-b703181bd35b/full',
  },
  {
    title:
      'Evaluación de la relación entre las propiedades físicas y químicas de la madera en Jacaranda mimosifolia, árbol patrimonial de la ciudad de Loja',
    authors: 'Aguirre González, Viviana Alexandra',
    date: '2023-01-31',
    image: 'muestras_de_Jacaranda_mimosifolia',
    link: 'https://dspace.unl.edu.ec/items/734e0666-17c1-4cee-bfdc-349154399032',
  },
  {
    title:
      'La belleza escénica y los servicios ecosistémicos de los árboles urbanos de la avenida Orillas del Zamora de la ciudad de Loja, Ecuador',
    autores: 'Chimbo Granda, Edgar Fabian',
    date: '2023-01-30',
    image: 'belleza_orillas_zamora',
    link: 'https://dspace.unl.edu.ec/items/e32ca48d-6557-45f1-82fb-48760f156867',
  },
  {
    title:
      'Caracterización anatómica cuantitativa, cualitativa y cambios intraanuales en la madera de 10 árboles urbanos de la ciudad de Loja',
    autores: 'Cueva Briceño, Eva Fernanda',
    date: '2023-01-13',
    image: 'caracterizacion_anatomica_cuantitativa',
    link: 'https://dspace.unl.edu.ec/items/443131f6-8d67-4727-a5a6-52dc85401d6c',
  },
  {
    title:
      'Evaluación de la relación entre las propiedades físicas y químicas de la madera en Chionanthus pubescens, árbol patrimonial de la ciudad de Loja',
    image: 'propiedades_suelo',
    authors: 'Chamba Shonda, Patricia Enith',
    date: '2023-01-04',
    link: 'https://dspace.unl.edu.ec/items/2a9143cf-131a-4cc7-b463-ec8a57721afc',
  },
]
